import { Navbar } from '@doist/marketist';
import { GTM_ID_NAVBAR_ITEM } from 'services/gtm';
import type { ComponentProps } from 'react';
export function NavbarItemTracked(props: ComponentProps<typeof Navbar.Item>) {
  return <Navbar.Item data-gtm-id={GTM_ID_NAVBAR_ITEM} {...props} data-sentry-element="unknown" data-sentry-component="NavbarItemTracked" data-sentry-source-file="navbar-item-track.tsx" />;
}